import React from "react";
import { useState, useEffect } from "react";
import { db } from "../database/firebase";
import { doc, getDoc } from "firebase/firestore";
import Modal from "../component/Modal";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import logo from "../assets/logocolor.svg";
import Footer from "../component/Footer";
import clases1 from "../assets/resultado2.jpeg";

const Clases1 = () => {
  const [clase, setClase] = useState(null);
  const [modalLink, setModalLink] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const openModalWithLink = (link) => {
    setModalLink(link);
    toggleModal();
  };

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "clases", "claseGrabada");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setClase(docSnap.data());
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error obteniendo el documento:", error);
      }
    };
    fetchData();
  }, []);

  console.log(clase === null ? "Cargando..." : clase);

  return (
    <div class="main">
      <FloatingWhatsApp
        phoneNumber="+5492236879502" // El número de teléfono al que se enviará el mensaje
        accountName="Rentable Inversor" // El nombre de la empresa o persona que ofrece el servicio
        statusMessage="Te responderé en menos de 24 horas" // El texto que indica el tiempo de respuesta
        chatMessage="Hola 👋 ¿te puedo ayudar en algo?" // El mensaje predeterminado que se mostrará en el chat
        placeholder="Escribe un mensaje" // El texto del campo de entrada
        darkMode={false} // El modo oscuro del botón y el chat
        avatar={logo} // La imagen del avatar
        chatboxStyle={{ boxShadow: "0 4px 8px rgba(0,0,0,0.2)" }} // El estilo del chat
      />
      <div class="main_platform_block mt-[50px] mx-auto flex flex-col sm:flex-row justify-center max-w-[1240px]">
        <div class="main_platform_image p-2">
          <img
            alt="platform"
            class="main_image max-w-auto h-auto sm:max-w-[580px] sm:max-h-[580px] sm:h-[580px] top-[-25px] lg:left-[-100px] xl:left-[-150px] rounded-2xl object-scale-down shadow-2xl shadow-black/60"
            src={clases1}
          />
        </div>
        <div class="main_platform_container flex flex-col max-w-full sm:max-w-[620px] w-full md:pl-[90px] pl-2">
          <h1 class="main_text font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[32px] 2xl:text-[32px] mb-[6px] mr-[24px] leading-[56px] tracking-tight whitespace-pre-line break-words">
            {clase?.titulo}
          </h1>
          <span class="main_subtext text-white/60 md:text-[14px] lg:text-[14px] xl:text-[16px] 2xl:text-[16px] leading-[24px] mr-[24px] mb-[4px] whitespace-pre-line break-words">
            {clase?.descripcion}
          </span>
          <div class="flex items-center space-x-2 mb-10">
            <h1 class="precio_curso main_text font-bold text-white md:text-[20px] lg:text-[20px] xl:text-[24px] 2xl:text-[20px] mr-[18px] leading-[56px] tracking-tight antialiased">
              ${clase?.precio}
            </h1>
            <span class="text-white"> {clase?.moneda} </span>
          </div>
          <div class="flex flex-col space-y-5 mx-auto md:mx-0">
            {clase?.link_binance && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_binance)}
                  class="btn bg-btnyellow rounded-[4px] p-18 text-white hover:text-btnyellow font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btnyellow/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                >
                  Pagar con BINANCE
                </button>
              </div>
            )}
            {clase?.link_mp && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_mp)}
                  class="btn bg-btnblue rounded-[4px] p-18 text-white hover:text-btnblue font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btnblue/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                >
                  Pagar con Mercado Pago
                </button>
              </div>
            )}
            {clase?.link_hotmart && (
              <div>
                <button
                  onClick={() => openModalWithLink(clase.link_hotmart)}
                  class="btn bg-btngray rounded-[4px] p-18 text-white hover:text-btngray font-bold ml-auto py-4 px-14 shadow-btn-shadow shadow-btngray/25 w-full hover:bg-[#ffffff] hover:shadow-btn-shadow hover:shadow-[#ffffff] transition duration-300 ease-in-out"
                >
                  Pagar con Debito / Credito
                </button>
              </div>
            )}
          </div>
          <Modal
            isOpen={isOpen}
            toggleModal={toggleModal}
            link={modalLink}
          ></Modal>

          <div class="flex flex-col md:flex-row mx-auto md:mx-0">
            <iframe
              class="w-[320px] h-[260px] shadow-[2px_4px_4px_rgb(0_0_0_/_25%)] flex justify-center border rounded-[10px] border-solid border-[#bcbcbc] mt-5"
              src="https://dolarhoy.com/i/cotizaciones/dolar-blue"
              title="Dolar Blue"
              frameborder="0"
            ></iframe>
            <div>
              <button
                class="ml-4 mt-4 text-white text-[14px] leading-[24px] font-[400] hover:underline"
                onClick={() => openModalWithLink("Transferencia")}
              >
                ¿Deseas abonar mediante transferencia bancaria?
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Clases1;
